export const US_STATE_CODES_BY_NAME = {
    alabama: "AL",
    alaska: "AK",
    arizona: "AZ",
    arkansas: "AR",
    california: "CA",
    colorado: "CO",
    connecticut: "CT",
    delaware: "DE",
    "district of columbia": "DC",
    florida: "FL",
    georgia: "GA",
    hawaii: "HI",
    idaho: "ID",
    illinois: "IL",
    indiana: "IN",
    iowa: "IA",
    kansas: "KS",
    kentucky: "KY",
    louisiana: "LA",
    maine: "ME",
    maryland: "MD",
    massachusetts: "MA",
    michigan: "MI",
    minnesota: "MN",
    mississippi: "MS",
    missouri: "MO",
    montana: "MT",
    nebraska: "NE",
    nevada: "NV",
    "new hampshire": "NH",
    "new jersey": "NJ",
    "new mexico": "NM",
    "new york": "NY",
    "north carolina": "NC",
    "north dakota": "ND",
    ohio: "OH",
    oklahoma: "OK",
    oregon: "OR",
    pennsylvania: "PA",
    "rhode island": "RI",
    "south carolina": "SC",
    "south dakota": "SD",
    tennessee: "TN",
    texas: "TX",
    utah: "UT",
    vermont: "VT",
    virginia: "VA",
    washington: "WA",
    "west virginia": "WV",
    wisconsin: "WI",
    wyoming: "WY",
} as const;

const STATE_CODES = new Set(Object.values(US_STATE_CODES_BY_NAME));
const STATE_NAMES_BY_CODE = Object.fromEntries(
    Object.entries(US_STATE_CODES_BY_NAME).map(([name, code]) => [
        code,
        name
            .split(" ")
            .map((word) =>
                word === "of"
                    ? word
                    : `${word.charAt(0).toUpperCase()}${word.slice(1)}`,
            )
            .join(" "),
    ]),
) as Record<string, string>;

export function normalizeUsState(
    value: string | null | undefined,
): string | undefined {
    const normalized = value?.trim().toLowerCase();
    if (!normalized) return undefined;
    if (normalized.length === 2) {
        const code = normalized.toUpperCase();
        return STATE_CODES.has(
            code as (typeof US_STATE_CODES_BY_NAME)[keyof typeof US_STATE_CODES_BY_NAME],
        )
            ? code
            : undefined;
    }
    return US_STATE_CODES_BY_NAME[
        normalized as keyof typeof US_STATE_CODES_BY_NAME
    ];
}

export function formatUsStateName(
    value: string | null | undefined,
): string | undefined {
    const code = normalizeUsState(value);
    return code ? STATE_NAMES_BY_CODE[code] : undefined;
}
